import {Component} from "react";
import ReactPlayer from "react-player"
import style from "./style.module.css"
import {BE_ADDR} from "../../../api/host"

class ResponsivePlayer extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        const windowWidth = window.innerWidth

        if (windowWidth <= 480) {

            return `${BE_ADDR}${this.props.value.source_mobile !== ""
                ? this.props.value.source_mobile
                : this.props.value.source_desktop}`
        }

        return `${BE_ADDR}${this.props.value.source_desktop !== ""
            ? this.props.value.source_desktop
            : this.props.value.source_mobile}`
    }

    render() {
        return (
            <div style={{
                height: "100%"
            }} className={style.playerWrapper}>
                <ReactPlayer
                    className={style.reactPlayer}
                    url={this.handleClick()}
                    width='100%'
                    height='100%'
                    playing={true}
                    muted={true}
                />
            </div>
        )
    }
}

export default ResponsivePlayer